import script from "./HrColor.vue?vue&type=script&setup=true&lang=js"
export * from "./HrColor.vue?vue&type=script&setup=true&lang=js"

import "./HrColor.vue?vue&type=style&index=0&id=c782fb3c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c782fb3c"]])

export default __exports__
import QColor from 'quasar/src/components/color/QColor.js';
import QSlider from 'quasar/src/components/slider/QSlider.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QColor,QSlider,QTab});
